const formatter = new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: 3 })

const formatPercentage = (value) => formatter.format(value / 100)

export default formatPercentage



// WEBPACK FOOTER //
// ./src/utils/formatters/formatPercentage.js